<template>
    <div v-if="campos" class="m-t">
      <e-row :class="css" mr>
        <e-col v-for="c in campos" :key="'campo-' + c.campo.id" :style="colStyle">
          <label class="text-black open-sans" style="font-size: 14px; font-weight: 500">{{ c.campo.nome }}</label>
          <p>
            <detect-input class="full-width" v-model="c.valor" :field="c.campo" :field-value="c" />
          </p>
        </e-col>

      </e-row>
    </div>
</template>

<script>
import CadastroBemMixin from "@/components/bem/components/include/CadastroBemMixin"
import DetectInput from "@/reuse/input/dynamic/DetectInput"

export default {
  name: "BemCampoSecao",
  props: {
    secao: {required: true},
    css: {
      default: 'erp-row-view col-limit-4 v2 view-wrap'
    },
    colStyle: {
      default: 'flex: 1; min-width: 100%; width: 100%;'
    }
  },
  components: {
    DetectInput
  },
  mounted() {
  },
  mixins: [CadastroBemMixin],
  data() {
    return {}
  },
  watch: {
  },
  computed: {
    campos () {
      console.log('CAMPOS', this.bem.campos)
      return this.bem.campos && this.bem.campos.filter(c => c.campo.secao && c.campo.secao.codigo === this.secao)
    }
  },
  methods: {
  }
}
</script>
